
// import React, { useState } from "react";
// import { NextIcon } from "../../../components/common/IconComponents";

// const TabbedNavigation = ({ tabs }) => {
//     // const defaultTabId = "notify-me"; // ID of the "Notify Me" tab
//     const [activeTab, setActiveTab] = useState(tabs[0].id);
//     // const [activeTab, setActiveTab] = useState(defaultTabId);

//     const handleTabClick = (tabId) => {
//         setActiveTab(tabId);
//     };

//     const renderTabContent = () => {
//         const activeTabObj = tabs.find((tab) => tab.id === activeTab);
//         if (activeTabObj) {
//             return activeTabObj.content;
//         }
//         return null;
//     };

//     return (
//         <div className="flex relative">
//             <div className="w-2/5 ps-2 border-r-2 border-th-bg">
//                 <h1 className="mt-4 text-[28px] font-medium">Settings</h1>
            
//                 <ul className="mt-24">
//                     {tabs.map((tab) => (
//                         <li
//                             key={tab.id}
//                             className={`flex items-center justify-between cursor-pointer text-base font-normal mb-4 py-2 px-4 rounded ${activeTab === tab.id ? "bg-th-bg text-activesettings-text border-r-2 border-enabled-btn rounded-none" : "bg-white text-disabled"
//                                 }`}
//                             onClick={() => handleTabClick(tab.id)}
//                         >
//                             {tab.label}
//                             <NextIcon className={`ml-2ta ${activeTab === tab.id ? "text-activesettings-text" : "text-disabled"
//                                 }`} />
//                         </li>
//                     ))}
//                 </ul>
//             </div>

//             <div className="w-3/5 px-2">{renderTabContent()}</div>
//         </div>
//     );
// };

// export default TabbedNavigation;





// import React, { useState } from "react";
// import { NextIcon } from "../../../components/common/IconComponents";

// const TabbedNavigation = ({ tabs }) => {
//     // const defaultTabId = "notify-me"; // ID of the "Notify Me" tab
//     const [activeTab, setActiveTab] = useState(tabs[0].id);
//     // const [activeTab, setActiveTab] = useState(defaultTabId);

//     const handleTabClick = (tabId) => {
//         setActiveTab(tabId);
//     };

//     const renderTabContent = () => {
//         const activeTabObj = tabs.find((tab) => tab.id === activeTab);
//         if (activeTabObj) {
//             return activeTabObj.content;
//         }
//         return null;
//     };

//     return (
//         <div className="flex">
//             <div className="w-2/5 ps-2 border-r-2 border-th-bg">
//                 <h1 className="mt-4 text-[28px] font-medium">Settings</h1>
//                 <ul className="mt-4">
//                     {tabs.map((tab) => (
//                         <li
//                             key={tab.id}
//                             className={`flex items-center justify-between cursor-pointer text-base font-normal mb-4 py-2 px-4 rounded ${activeTab === tab.id ? "bg-th-bg text-activesettings-text border-r-2 border-enabled-btn rounded-none" : "bg-white text-disabled"
//                                 }`}
//                             onClick={() => handleTabClick(tab.id)}
//                         >
//                             {tab.label}
//                             <NextIcon className={`ml-2ta ${activeTab === tab.id ? "text-activesettings-text" : "text-disabled"
//                                 }`} />
//                         </li>
//                     ))}
//                 </ul>
//             </div>

//             <div className="w-3/5 px-2">{renderTabContent()}</div>
//         </div>
//     );
// };

// export default TabbedNavigation;





       




// import React, { useState } from "react";
// import { TabbedLinks } from "../../../utils/TabbedLinks";

// const TabbedNavigation = ({ initialTab, handleTabClick, tabs }) => {
//     const [activeTab, setActiveTab] = useState(initialTab || tabs[0].id);

//     const handleTabClick = (tabId) => {
//         setActiveTab(tabId);
//     };

//     const renderTabContent = () => {
//         const activeTabObj = tabs.find((tab) => tab.id === activeTab);
//         if (activeTabObj) {
//             return activeTabObj.content;
//         }
//         return null;
//     };

//     return (
//         <div>
//             <TabbedLinks activeTab={activeTab} handleTabClick={handleTabClick} tabs={tabs} />
//             <div className="p-4 bg-gray-100">{renderTabContent()}</div>
//         </div>
//     );
// };

// export default TabbedNavigation;


// import React, { useState } from "react";
// import { TabbedLinks } from "../../../utils/TabbedLinks";

// const TabbedNavigation = ({ activeTab, handleTabClick, tabs }) => {
//     const [activeTab, setActiveTab] = useState(tabs[0].id);

//     const handleTabClick = (tabId) => {
//         setActiveTab(tabId);
//     };

//     const renderTabContent = () => {
//         const activeTabObj = tabs.find((tab) => tab.id === activeTab);
//         if (activeTabObj) {
//             return activeTabObj.content;
//         }
//         return null;
//     };

//     return (
//         <div>
//             <TabbedLinks activeTab={activeTab} handleTabClick={handleTabClick} tabs={tabs} />
//             <div className="p-4 bg-gray-100">{renderTabContent()}</div>
//         </div>
//     );
// };

// export default TabbedNavigation;




// import React, { useState } from "react";
// import { TabbedLinks } from "../../../utils/TabbedLinks";

// const TabbedNavigation = ({ tabs }) => {
//     const [activeTab, setActiveTab] = useState(tabs[0].id);

//     const handleTabClick = (tabId) => {
//         setActiveTab(tabId);
//     };

//     const renderTabContent = () => {
//         const activeTabObj = tabs.find((tab) => tab.id === activeTab);
//         if (activeTabObj) {
//             return activeTabObj.content;
//         }
//         return null;
//     };

//     return (
//         <div>
//             <TabbedLinks activeTab={activeTab} handleTabClick={handleTabClick} tabs={tabs} />
//             <div className="p-4 bg-gray-100">{renderTabContent()}</div>
//         </div>
//     );
// };

// export default TabbedNavigation;








// import React, { useState } from "react";
// import classNames from "classnames";

// const TabbedNavigation = () => {
//     const [activeTab, setActiveTab] = useState("companyProfile");

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//     };

//     const tabItems = [
//         { id: "companyProfile", label: "Company's Profile" },
//         { id: "myProfile", label: "My Profile" },
//         { id: "password", label: "Password" },
//         { id: "notification", label: "Notification" },
//         { id: "maintainRoles", label: "Maintain Roles" },
//     ];

//     const renderTabContent = () => {
//         switch (activeTab) {
//             case "companyProfile":
//                 return <p>Company's Profile content goes here.</p>;
//             case "myProfile":
//                 return <p>My Profile content goes here.</p>;
//             case "password":
//                 return <p>Password content goes here.</p>;
//             case "notification":
//                 return <p>Notification content goes here.</p>;
//             case "maintainRoles":
//                 return <p>Maintain Roles content goes here.</p>;
//             default:
//                 return null;
//         }
//     };

//     return (
//         <div className="flex">
//             <div className="w-1/4">
//                 <ul className="space-y-2">
//                     {tabItems.map((item) => (
//                         <li
//                             key={item.id}
//                             className={classNames(
//                                 "cursor-pointer py-2 px-4 rounded",
//                                 activeTab === item.id
//                                     ? "bg-blue-500 text-white"
//                                     : "bg-gray-200"
//                             )}
//                             onClick={() => handleTabClick(item.id)}
//                         >
//                             {item.label}
//                         </li>
//                     ))}
//                 </ul>
//             </div>
//             <div className="w-3/4 p-4 bg-gray-100">{renderTabContent()}</div>
//         </div>
//     );
// };

// export default TabbedNavigation;



import React, { useState } from "react";
import { NextIcon } from "../../../components/common/IconComponents";

const TabbedNavigation = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const renderTabContent = () => {
    const activeTabObj = tabs.find((tab) => tab.id === activeTab);
    if (activeTabObj) {
      return activeTabObj.content;
    }
    return null;
  };

  return (
    <div className="relative flex flex-col md:flex-row">
      <div className="md:w-2/5 md:ps-2 md:border-r-2 border-th-bg">
        <nav className="w-full md:w-[281px] lg:w-[453px] fixed z-20 top-0 bg-white">
          <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Settings</h1>
        </nav>
  
        <div className="mt-24">
            <ul>
                {tabs.map((tab) => (
                    <li
                        key={tab.id}
                        className={`flex items-center justify-between cursor-pointer text-xs md:text-base font-normal mb-4 p-2 md:p-3 rounded ${activeTab === tab.id
                                ? "bg-th-bg text-activesettings-text border-r-2 border-enabled-btn rounded-none"
                                : "bg-white text-disabled"
                            }`}
                        onClick={() => handleTabClick(tab.id)}
                    >
                        {tab.label}
                        <NextIcon
                            className={`ml-2ta ${activeTab === tab.id ? "text-activesettings-text" : "text-disabled"
                                }`}
                        />
                    </li>
                ))}
            </ul>
        </div>    
      </div>

      <div className="w-auto md:w-3/5 md:px-2">
          {renderTabContent()}
      </div>
    </div>
  );
};

export default TabbedNavigation;
